import { createRootRoute, createRoute, createRouter, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { searchSchema } from "@po/shared";
import { AdminPage } from "./pages/AdminPage";
import { Dashboard } from "./pages/Dashboard";
import { SignInPage } from "./pages/SignInPage";

const rootRoute = createRootRoute({ component: () => <Outlet /> });

export const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  // All filter state lives in typed, validated search params (SPEC §6.3). Bad values are dropped.
  validateSearch: (raw: Record<string, unknown>) => {
    const r = searchSchema.safeParse(raw);
    if (r.success) return r.data;
    const clean: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(raw)) {
      const one = searchSchema.safeParse({ [k]: v });
      if (one.success) Object.assign(clean, one.data);
    }
    return searchSchema.parse(clean);
  },
  component: Dashboard,
});

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign-in",
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: SignInPage,
});

export const adminRoute = createRoute({ getParentRoute: () => rootRoute, path: "/admin", component: AdminPage });

export const router = createRouter({
  routeTree: rootRoute.addChildren([dashboardRoute, signInRoute, adminRoute]),
  defaultPreload: false,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
